/**
 * @generated SignedSource<<91569fbe41bcbebc760decb30b17edb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceDescription_productizedService$data = {
  readonly blocknoteContent: ContraAPIScalars.JSON | null;
  readonly blocknoteProcessDescription: ContraAPIScalars.JSON | null;
  readonly faqs: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answer: string;
        readonly id: string;
        readonly question: string;
      };
    }>;
  };
  readonly " $fragmentType": "ProductizedServiceDescription_productizedService";
};
export type ProductizedServiceDescription_productizedService$key = {
  readonly " $data"?: ProductizedServiceDescription_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceDescription_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceDescription_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocknoteContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocknoteProcessDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServiceFAQConnection",
      "kind": "LinkedField",
      "name": "faqs",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductizedServiceFAQEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductizedServiceFAQ",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "question",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "answer",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "740be7820c13a1a5db67996c20615dc6";

export default node;
